//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
    import cmBlank from '@/components/cmBlank';
    import cmLoadmore from '@/components/cmLoadmore.vue'

    export default {
         components: {
            cmBlank,cmLoadmore
        },
        data(){
            return {
                code:'',
                blankShow:false,
                loadStatus:false,
                loadmoreText:'正在加载。。。',
                busy:false,
                list:[],
                where:[],
                hasNext:0,
                pageFlag:2,
                lastId:0,
                type:0,
                types:[
                    {
                        'key':0,
                        'text':'洗前通知',
                    },
                    {
                        'key':1,
                        'text':'风险确认',
                    },
                ],
                status:0,
                statusArr:[],
            }
        },
        mounted(){
            this.config();
            let grade = this.$func.getLocal('grade');
            if(grade == 13 || grade == 14){
                this.status = 1;
                this.statusArr = [
                    {
                        'key':1,
                        'text':'待审核',
                    },
                    {
                        'key':2,
                        'text':'待通知',
                    },
                    {
                        'key':3,
                        'text':'待确认',
                    },
                    {
                        'key':4,
                        'text':'已确认',
                    },
                ];
            }else{
                this.status = 3;
                this.statusArr = [
                    {
                        'key':3,
                        'text':'待确认',
                    },
                    {
                        'key':4,
                        'text':'已确认',
                    },
                ];
            }
        },
        methods: {
            select(i){
                // this.where = [];
                // this.type = i;
                this.status = i;
                this.lastId = 0;
                this.pageFlag = 2;
                this.list = [];
                this.loadmore();
            },
            reset(){
                this.code = '';
                this.list = [];
                this.lastId = 0;
                this.hasNext = 0;
                this.getList();
            },
            copy(val){
                this.$func.copy(val,event);
            },
            search(){
                this.list = [];
                this.lastId = 0;
                this.hasNext = 0;
                this.getList();
            },
            barOrder(code){
                this.$router.push({name:'barOrder',params:{code:code}})
            },
            getList(){
                this.$api.clothesConfirmList({last_id:this.lastId,page_flag:this.pageFlag,code:this.code,type:this.type,status:this.status}).then((res)=>{
                    if(res){
                        if(!this.lastId){
                            this.blankShow = res.data.length > 0 ? false : true;
                        }
                        this.hasNext = res.hasNext;
                        this.lastId = res.lastId;
                        res.data.forEach((item)=>{
                            this.list.push(item);
                        });
                    }
                })  
            },
            info(id){
                this.$router.push({name:'clothesConfirmInfo',params:{id:id}})
            },
            loadmore(){
                if(this.lastId > 0 && !this.hasNext){
                    this.busy = true;
                    this.loadStatus = true;
                    this.loadmoreText = '没有更多了。。。'
                    return ;
                }
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '正在加载。。。';
                this.getList();
                setTimeout(()=>{
                    if(this.blankShow){
                        this.busy = true;
                        this.loadStatus = false;
                        this.loadmoreText = '没有更多了。。。'
                    }else{
                        if(this.hasNext > 0){
                            this.loadStatus = false;
                            this.busy = false;
                        }else{
                            this.busy = true;
                            this.loadStatus = true;
                            this.loadmoreText = '没有更多了。。。'
                        }
                    }
                },1500)
            },
            scanQRCode(){
                let that = this;
                wx.ready(()=> {
                    wx.scanQRCode({
                    needResult: 1,
                    scanType: ['barCode'],
                    success: function (res) {
                        setTimeout(()=>{
                            that.code = that.$func.parseScanResult(res.resultStr);
                            that.getList();
                        },300);
                    }
                    })
                });
                wx.error((res)=> {
                    console.log(res)
                    // alert(res.errMsg);
                })
            },  
            config(){
                let url = (window.location.href).split('#');
                if(url[0].indexOf('?') != '-1'){
                    url = url[0].split('?');
                }
                this.$api.wxSign({url:url[0]}).then((res)=>{
                    if(res){
                        wx.config({
                            debug: false, 
                            appId: res.data.appId,
                            timestamp: res.data.timestamp,
                            nonceStr: res.data.nonceStr,
                            signature:res.data.signature,
                            jsApiList: [
                                "scanQRCode"
                            ]
                        });
                    }
                })
            },
        },
    }



// WEBPACK FOOTER //
// ./src/pages/clothesConfirm.vue